import Observer from "../../services/helpers/Observer"
import { v4 as uuidv4 } from 'uuid';
import {KEY_GROUP} from "@frontend/constants/templates-field-prefixes";

export const EVENTS = {
    UPDATED: 'updated',
    ADDED: 'added',
    REMOVED: 'removed'
}

// Allocate names from the complete saved list, independently of UI order/filters.
export function withGroupNames(groups) {
    const items = Array.isArray(groups) ? groups : [];
    const names = new Set(items.map(group => group.name).filter(Boolean));
    let number = 1;
    return items.map(group => {
        if (group.name) return group;
        while (names.has(`Group ${number}`)) number++;
        const name = `Group ${number++}`;
        names.add(name);
        return { ...group, name };
    });
}

export default class GroupFields extends Observer {

    items = []

    setItems(items) {
        this.items = withGroupNames(items)
    }

    add(group) {
        group.id = KEY_GROUP + uuidv4()
        this.items = withGroupNames([...this.items, group])
        group = this.items[this.items.length - 1]

        this.dispatch(EVENTS.UPDATED, this)
        this.dispatch(EVENTS.ADDED, { group })

        return group
    }

    update(id, values) {
        let updated = false

        const updateGroups = (groups) => groups.map(group => {
            if (group.id === id) {
                updated = true

                return { ...group, ...values }
            }

            return {
                ...group,
                fields: Array.isArray(group.fields)
                    ? group.fields.map(field => {
                        if (!field || typeof field !== 'object') return field

                        return updateGroups([field])[0]
                    })
                    : []
            }
        })

        this.items = updateGroups(this.items)

        if (updated) {
            this.dispatch(EVENTS.UPDATED, this)
        }
    }

    remove(id) {
        const removeGroup = (groups) => groups
            .filter(group => group.id !== id)
            .map(group => ({
                ...group,
                fields: Array.isArray(group.fields)
                    ? group.fields.map(field => {
                        if (!field || typeof field !== 'object') return field

                        return removeGroup([field])[0]
                    }).filter(Boolean)
                    : []
            }))

        this.items = removeGroup(this.items)

        this.dispatch(EVENTS.UPDATED, this)
        this.dispatch(EVENTS.REMOVED, { id })
    }

    getGroupByFieldId(fieldId) {
        const findGroup = (groups) => {
            for (const group of groups) {
                const fields = Array.isArray(group.fields) ? group.fields : []

                for (const field of fields) {
                    if (field === fieldId) return group

                    if (field && typeof field === 'object') {
                        if (field.id === fieldId) return group

                        const nestedGroup = findGroup([field])
                        if (nestedGroup) return nestedGroup
                    }
                }
            }

            return undefined
        }

        return findGroup(this.items)
    }

  ungroup(id) {
    const ungroupItems = (groups) => {
      const result = []

      groups.forEach(group => {
        if (group.id === id) {
          result.push(
            ...(Array.isArray(group.fields) ? group.fields : [])
              .filter(field => field && typeof field === 'object')
          )
          return
        }

        result.push({
          ...group,
          fields: Array.isArray(group.fields)
            ? ungroupFields(group.fields)
            : []
        })
      })

      return result
    }

    const ungroupFields = (fields) => {
      const result = []

      fields.forEach(field => {
        if (!field || typeof field !== 'object') {
          result.push(field)
          return
        }

        if (field.id === id) {
          result.push(...(Array.isArray(field.fields) ? field.fields : []))
          return
        }

        result.push({
          ...field,
          fields: ungroupFields(field.fields || [])
        })
      })

      return result
    }

    this.items = ungroupItems(this.items)
    this.dispatch(EVENTS.UPDATED, this)
  }

    getItems() {
        return this.items
    }
}
